import { render, staticRenderFns } from "./IconInquiry.vue?vue&type=template&id=c0be937c&"
import script from "./IconInquiry.vue?vue&type=script&lang=js&"
export * from "./IconInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports